import { InputAdornment, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  InputControl,
  Loader,
  ScrollButton,
  SearchChip,
  SelectChip,
} from "../../../shared";
import CloseIcon from "@mui/icons-material/Close";

import TemplateCustomTable from "../components/TemplateCustomTable";

export const GenerateTemplates = ({
  categorylistQuery,
  templates,
  onChangeFilter,
  onSearchChange,
  searchHandler,
  handleCustomFieldChange,
  recipelistQuery,
  validator,
  templateDetails,
}) => {
  const [search, setSearch] = useState("");
  const categoryRef = useRef(null);

  const handleHorizontalScroll = (element, speed, distance, step) => {
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.scrollLeft += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= distance) {
        clearInterval(slideTimer);
      }
    }, speed);
  };

  const onChange = (event) => {
    const { value } = event.target;
    setSearch(value);
    onSearchChange(value, templates.groupedDatas);
  };

  const clearSearch = () => {
    setSearch("");
    searchHandler("");
  };

  useEffect(() => {
    return () => {
      clearSearch();
    };
  }, []);

  return templateDetails.isLoading ? (
    <Loader />
  ) : (
    <>
      {validator.current.purgeFields()}
      <Stack direction="row" gap="10px" alignItems="center" pl="16px">
        <InputControl
          sx={{ width: "200px", borderRadius: "10px" }}
          type="table-search"
          placeholder="Search"
          onChange={onChange}
          value={search}
          // value={templates.filter.search}
          endAdornment={
            templates.filter.search && (
              <InputAdornment sx={{ cursor: "pointer" }} position="end">
                <CloseIcon size="large" onClick={clearSearch} />
              </InputAdornment>
            )
          }
        />
        <ScrollButton
          categoryRef={categoryRef}
          onClick={handleHorizontalScroll}
          step={-10}
        >
          <img alt="details" src="/icons/Intersect.png" />
        </ScrollButton>
        {search && (
          <SearchChip
            key={templates.totalTemplateSearchResult}
            count={templates.totalTemplateSearchResult}
            value={search}
          />
        )}
        <Stack
          direction="row"
          width="78vw"
          overflow="auto"
          gap={1}
          className="scroll-hide"
          ref={categoryRef}
        >
          {categorylistQuery?.data?.map((v, i) => (
            <SelectChip
              key={i}
              value={v}
              isSelected={
                search
                  ? false
                  : templates.filter.category
                    ? templates.filter.category === v.id
                    : i === 0
              }
              sx={search && { cursor: "not-allowed" }}
              onClick={() => {
                !search && onChangeFilter(v, templates.groupedDatas);
              }}
            />
          ))}
        </Stack>
        <ScrollButton
          categoryRef={categoryRef}
          onClick={handleHorizontalScroll}
          step={10}
        >
          <img alt="details" src="/icons/Intersect1.png" />
        </ScrollButton>
      </Stack>

      <TemplateCustomTable
        rows={templates.templateResultRows}
        handleCustomFieldChange={handleCustomFieldChange}
        data={templates}
        recipelistQuery={recipelistQuery}
      />
    </>
  );
};
